/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { PriceBookRestService, PriceBookUsageWithWeb } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { PriceBookListItem, PriceBookListItemCheckUsage } from './price-book.model';
import { FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class PriceBookListBusinessService implements InitViewService {

  constructor(private restService: PriceBookRestService,
              private dictionaryService: DictionaryService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {
  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('priceBooks'),
      priceBookUsage: this.dictionaryService.getByEnum(PriceBookUsageWithWeb),
      filter: this.filterService.get(FilterNames.priceBooks),
    };
  }

  findAllAsDataSource(filter: any): SlicedDataSource<PriceBookListItem> {
    return this.restService.findAllAsDataSource({
                                                  ...filter,
                                                  autocomplete: false,
                                                  showUnreleased: true,
    });
  }

  checkUsage(priceBook: PriceBookListItem): Observable<PriceBookListItemCheckUsage> {
    return this.restService.checkUsage(priceBook);
  }

  remove(priceBook: PriceBookListItem, checkUsage: PriceBookListItemCheckUsage): Observable<any> {
    return this.restService.remove(priceBook, checkUsage);
  }
}
